/**
 * Copyright 2024 Phenix Real Time Solutions, Inc. Confidential and Proprietary. All Rights Reserved.
 */
import * as styled from 'styled-components';
import {theme, paddings} from 'components/shared/theme';

const {
  colors,
  spacing,
  primaryFontSize,
  fontSizeXl
} = theme;

interface ICopyrightContainer {
  isLoggedIn: boolean;
}

export const CopyrightContainer = styled.default.div<ICopyrightContainer>`
  display: flex;
  position: fixed;
  bottom: 0;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: ${paddings.medium};
  background-color: ${colors.gray900};
  z-index: 999;

  ${({isLoggedIn}) => !isLoggedIn && styled.css`
    flex-direction: column;
    line-height: ${fontSizeXl};
    background-color: ${colors.transparent};
  `}

  & a {
    text-decoration: none;
    color: ${colors.white};
    font-size: ${primaryFontSize};
  }
`;

export const SeparationDot = styled.default.div`
  width: 5px;
  height: 5px;
  border: none;
  border-radius: 50%;
  background-color: ${colors.white};
  margin: 0 ${spacing.xSmall};
`;

export const LinksContainer = styled.default.div`
  display: flex;
  align-items: center;
`;